import { layoutRoute } from '@app/router/layout';
import { createRoute } from '@tanstack/react-router';
import Dashboard from '@modules/dashboard/presentation/pages/Dashboard';

export const DashboardRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/dashboard',
  beforeLoad: () => ({
    breadcrumb: { key: 'dashboard' },
    featureName: 'dashboards.module',
  }),
  component: () => (
    <Dashboard />
  ),
});
